import { render } from "./ShoreiChartComponent.vue?vue&type=template&id=3b2eec36&scoped=true&ts=true"
import script from "./ShoreiChartComponent.vue?vue&type=script&lang=ts"
export * from "./ShoreiChartComponent.vue?vue&type=script&lang=ts"

import "./ShoreiChartComponent.vue?vue&type=style&index=0&id=3b2eec36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2eec36"]])

export default __exports__